<template>
    <fieldset class="checkbox-list">
        <label class="checkbox" v-for="(option, index) in options">
            <input
                    type="checkbox"
                    :id="index"
                    :name="index"
                    :checked="store.hasOption(option, option.type)"
                    @input="updateOption(option, $event)">
            <div class="checkbox__box">
                <svg class="icon-checkmark" width="20" height="20" viewBox="0 0 20 20">
                    <polyline class="check-line" points="4 11 8 15 16 6"></polyline>
                </svg>
            </div>
            <span class="checkbox__label" :for="index">{{ option.label }}</span>
        </label>
    </fieldset>
</template>

<script>
    import CodeOutput from '../../Store/CodeOutput';

    export default {
        name: 'Options',

        props: {
            options: {},
            value: {},
        },

        computed: {
            store() {
                return new CodeOutput();
            },
        },


        methods: {
            updateOption: function(option, event) {
                let shouldAdd = event.target.checked;

                if(shouldAdd)
                    this.store.pushOption(option, option.type);
                else
                    this.store.removeOption(option, option.type);

                this.$emit('update');
            },
        },

    }
</script>

<style scoped>

</style>